import { POPUP_OPEN, POPUP_CLOSE } from "./CommonActionType";

const apiConfig = window as any;

const initialState = {
    isOpen: false,
    imageSrc: null as string | null,
};

export function PopupReducer(state = initialState, action: any) {
    switch (action.type) {
        case "POPUP_OPEN":
            return { ...state, isOpen: true, imageSrc: action.payload };
        case "POPUP_CLOSE":
            return { ...state, isOpen: false, imageSrc: null };
        default:
            return state;
    }
}

export const openPopup = (src: string) => ({ type: "POPUP_OPEN", payload: src });
export const closePopup = () => ({ type: "POPUP_CLOSE" });
